import ExtCodeComponentLoader from "../../../components/Common/ExtCodeComponentLoader"

const LoginPage = () => {
    return <ExtCodeComponentLoader baseComponentPath='pages/login/loginPage/LoginPage' />
}
export default LoginPage